/**
 * V1.8.3 — Fixture catalog. Maps `type` strings emitted by the AI to:
 *   - label    : short uppercase glyph label rendered in the 2D plan
 *   - fillD    : light-mode fill in Diagram mode (cool warm-gray palette)
 *   - fillA    : Architectural-mode fill (slightly warmer cream)
 *   - stroke   : outline color
 *   - shape    : "rect" (default) or "circle" (toilet) — keeps the schematic
 *                visually readable at glance
 *
 * Anything not in this map falls back to a generic gray rectangle labelled
 * with the raw type string (so future AI emissions don't crash the canvas).
 *
 * The 3D viewport DOES NOT render fixtures — they exist only in the 2D plan
 * (loose schematic) and in the paid Architectural PDF (with measurements).
 */

const FIXTURES = {
  fridge:         { label: "REF",   fillD: "#dbeafe", fillA: "#f1ede4", stroke: "#1d4ed8" },
  range:          { label: "RNG",   fillD: "#fee2e2", fillA: "#f1ede4", stroke: "#b91c1c" },
  dishwasher:     { label: "DW",    fillD: "#e0f2fe", fillA: "#f1ede4", stroke: "#0369a1" },
  sink:           { label: "SINK",  fillD: "#cffafe", fillA: "#f1ede4", stroke: "#0e7490" },
  kitchen_island: { label: "ISLAND", fillD: "#fef3c7", fillA: "#f1ede4", stroke: "#a16207" },
  cabinets:       { label: "CAB",   fillD: "#fef9c3", fillA: "#f5efe1", stroke: "#854d0e" },
  pantry:         { label: "PANTRY", fillD: "#fef9c3", fillA: "#f5efe1", stroke: "#713f12" },
  toilet:         { label: "WC",    fillD: "#f3f4f6", fillA: "#f1ede4", stroke: "#3f3f46", shape: "circle" },
  vanity:         { label: "VAN",   fillD: "#f5f3ff", fillA: "#f1ede4", stroke: "#5b21b6" },
  shower:         { label: "SHWR",  fillD: "#e0e7ff", fillA: "#f1ede4", stroke: "#3730a3" },
  tub:            { label: "TUB",   fillD: "#dbeafe", fillA: "#f1ede4", stroke: "#1e40af" },
  washer:         { label: "W",     fillD: "#ecfeff", fillA: "#f1ede4", stroke: "#155e75" },
  dryer:          { label: "D",     fillD: "#ffe4e6", fillA: "#f1ede4", stroke: "#9f1239" },
  water_heater:   { label: "WH",    fillD: "#fef3c7", fillA: "#f1ede4", stroke: "#a16207" },
};

export function getFixtureStyle(type) {
  const key = String(type || "").toLowerCase().trim();
  return FIXTURES[key] || {
    label: key.slice(0, 4).toUpperCase() || "FX",
    fillD: "#e5e7eb",
    fillA: "#f1ede4",
    stroke: "#52525b",
  };
}

export const FIXTURE_TYPES = Object.keys(FIXTURES);
